export default "__VITE_ASSET__VaVuT9Zo__"